import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router";
import VueLoading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "./assets/scss/main.scss";
import * as apolloProvider from "./apollo.provider";
import "@/assets/scss/main.scss";

// Wrap the App component with the apolloProvider to make it available to all child components
const app = createApp({
	render: () => h(App),
});
app.use(router).use(apolloProvider.provider).use(VueLoading).mount("#calc-app");
